export default __webpack_public_path__ + "img/cmCvXrNJ.ae347996.svg";